(ns app.front.view.attachment.list-v2
  (:require [app.domain.attachment.model :as attachment-model]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list.util :as list-util]
            [app.front.view.attachment.subs :as attachment-subs]
            [clojure.string :as str]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]))

(defn- compare-values [value-fn]
  (fn [a b]
    (compare (or (value-fn a) "")
             (or (value-fn b) ""))))

(defn- attachment-types-sort-value [lang attachment]
  (->> attachment
       :attachment/types
       (map #(attachment-common/attachment-type-label % lang))
       sort
       (str/join ", ")))

(defn- filename-sort-value [attachment]
  (-> attachment
      list-util/latest-file
      :attachment.version.file/filename))

(defn- version-sort-value [attachment]
  (-> attachment
      attachment-model/latest-attachment-version
      :attachment.version/version))

(defn- modified-sort-value [attachment]
  (get-in attachment [:latest-change :ts]))

(defn- modified-by-sort-value [attachment]
  (get-in attachment [:latest-change :user]))

(defn- version-column [tr attachment]
  (some->> attachment
           version-sort-value
           vector
           (tr [:attachments/version-number])))

(defn- latest-version-column [tr property? bond? attachment]
  [:<>
   [:div.attachment-table__file-name.truncate
    (filename-sort-value attachment)]
   (when-not (or property? bond?)
     [:div.attachment-table__version
      (version-column tr attachment)])])

(defn- modified-date-column [attachment]
  (some->> attachment
           modified-sort-value
           ((<sub [::date-util/date-time-fn]))))

(defn attachment-status [tr {:db/keys [id] :as attachment}]
  (let [acceptance-value (<sub [::attachment-subs/latest-acceptance-value id])
        authority?       (<sub [:session/authority-user?])]
    (cond
      (:attachment/locked-for-editing-by attachment)
      {:status :notification
       :text   (tr [:review/attachment-in-markup])}

      (= acceptance-value :acceptance.value/ok)
      {:status :ok
       :text   (tr [:attachments/ok])}

      (= acceptance-value :acceptance.value/needs-changes)
      {:status (if authority? :task :attention)
       :text   (tr [:attachments/changes-needed])}

      :else
      {:status (if authority? :attention :task)
       :text   (tr [:attachments/new-version])})))

(defn attachment-columns
  [{:keys [bond? editable? lang property? show-visibility? tr]}]
  [[:entity.type/attachment
    (fn [{:db/keys [id]}]
      [list-util/attachment-types-column (util/mmap id)])
    {:flex      2
     :min-width "160px"
     :sorting   (compare-values (partial attachment-types-sort-value lang))}]
   [:review/attachment-latest-version
    (partial latest-version-column tr property? bond?)
    {:flex      2
     :min-width "180px"
     :truncate? true
     :sorting   (compare-values filename-sort-value)}]
   (when (and editable? (not (or bond? property?)))
     [:attachment/status
      (fn [attachment]
        (:text (attachment-status tr attachment)))
      {:width   "200px"
       :sorting (compare-values #(:text (attachment-status tr %)))}])
   (when show-visibility?
     [:attachment/visibility
      (fn [{:db/keys [id]}]
        [list-util/visibility-column (util/mmap id tr)])
      {:min-width "130px"}])
   [:latest-change
    (fn [{:db/keys [id]}]
      [list-util/modified-column (util/mmap id)])
    {:min-width "170px"
     :sorting   (compare-values modified-sort-value)}]
   [:attachment/types
    (partial attachment-types-sort-value lang)
    {:hidden-by-default? true
     :min-width          "160px"
     :sorting            (compare-values (partial attachment-types-sort-value lang))}]
   [:attachment/file-name
    filename-sort-value
    {:hidden-by-default? true
     :min-width          "180px"
     :truncate?          true
     :sorting            (compare-values filename-sort-value)}]
   [:attachment.version/version
    (partial version-column tr)
    {:hidden-by-default? true
     :min-width          "100px"
     :sorting            (compare-values version-sort-value)}]
   [:attachment/modified-date
    modified-date-column
    {:hidden-by-default? true
     :min-width          "170px"
     :sorting            (compare-values modified-sort-value)}]
   [:attachment/modified-by
    modified-by-sort-value
    {:hidden-by-default? true
     :min-width          "150px"
     :sorting            (compare-values modified-by-sort-value)}]
   [:description
    #(or (:attachment/contents %) "")
    {:hidden-by-default? true
     :min-width          "160px"
     :sorting            (compare-values :attachment/contents)}]])
